import { render, staticRenderFns } from "./FinancialYearIndex.vue?vue&type=template&id=510222dc"
import script from "./FinancialYearIndex.vue?vue&type=script&lang=js"
export * from "./FinancialYearIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports